import { render, staticRenderFns } from "./RenewAffiliateRequest.vue?vue&type=template&id=54ce5f03"
import script from "./RenewAffiliateRequest.vue?vue&type=script&lang=ts"
export * from "./RenewAffiliateRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports